(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pheres-collection-grid"] && !Shopify.designMode) return;
  try {
    
  // Filters are built from what is actually on the page rather than a fixed list,
  // so a collection with no rubies never offers a ruby button. Client-side because
  // 19 pieces fit on one page — there is nothing to fetch.
  class PheresFilter extends HTMLElement {
    connectedCallback() {
      const root = this.closest('section');
      this.grid = root?.querySelector('[ref="grid"]');
      if (!this.grid) return;
      this.cells = [...this.grid.querySelectorAll('.pgrid__cell')].filter((c) => c.dataset.stones !== undefined);
      if (this.cells.length < 2) return;

      this.breaks = [...this.grid.querySelectorAll('.pgrid__break')];
      this.count = root.querySelector('[ref="count"]');
      this.none = root.querySelector('[ref="none"]');
      this.all = this.querySelector('[ref="all"]');

      // SPEC §7 — URL state. Facets write to the query string so a filtered view
      // is shareable, and a shared link arrives already filtered.
      const params = new URLSearchParams(location.search);
      this.state = { stone: params.get('stone'), metal: params.get('metal') };

      this.build('stones', 'stone', (c) => (c.dataset.stones || '').split(' ').filter(Boolean));
      this.build('metals', 'metal', (c) => (c.dataset.metal ? [c.dataset.metal] : []));
      // Both sets can be dropped for want of a second value. A row with nothing to
      // choose between is not a filter, so it stays hidden rather than rendering as
      // a lone chip under a hairline.
      if (!this.querySelector('.pfacet__chip:not(.pfacet__chip--all)')) return;

      if (this.all && !this.allBound) {
        this.all.addEventListener('click', () => { this.state = { stone: null, metal: null }; this.sync(); this.settle(); });
        this.allBound = true;
      }

      this.hidden = false;
      this.sync();
    }

    build(refName, key, read) {
      const host = this.querySelector(`[ref="${refName}"]`);
      if (!host) return;
      const values = [...new Set(this.cells.flatMap(read))].sort();
      if (values.length < 2) { host.closest('.pfacet__set')?.remove(); this.state[key] = null; return; }
      // A shared link can carry a value this collection does not have. Honouring
      // it would hide every card and show the empty state over a full catalogue,
      // so an unknown value is dropped rather than applied.
      if (this.state[key] && !values.includes(this.state[key])) this.state[key] = null;
      host.replaceChildren();
      values.forEach((v) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'pfacet__chip';
        b.dataset.value = v;
        b.textContent = v.charAt(0).toUpperCase() + v.slice(1);
        b.setAttribute('aria-pressed', String(this.state[key] === v));
        b.addEventListener('click', () => {
          this.state[key] = this.state[key] === v ? null : v;
          this.sync();
          this.settle();
        });
        host.appendChild(b);
      });
    }

    // A chip is a decision, so the popover gets out of the way and the reader lands on
    // the first result. Left open it covered the count it had just changed.
    settle() {
      this.querySelector('.pfacet__pop')?.removeAttribute('open');
      this.grid.scrollIntoView();
    }

    // With the popover shut, the trigger is the only thing saying what is on. One
    // facet is named; two would not fit the row beside the count and the sort, so they
    // are counted.
    paintTrigger() {
      const label = this.querySelector('[ref="triggerLabel"]');
      if (!label) return;
      const on = [this.state.stone, this.state.metal].filter(Boolean);
      const base = label.dataset.base;
      if (on.length === 0) label.textContent = base;
      else if (on.length === 1) label.textContent = `${base}: ${on[0].charAt(0).toUpperCase()}${on[0].slice(1)}`;
      else label.textContent = `${base}: ${on.length}`;
    }

    // One pass: mark the chips, hide the cells, repaint the count and the trigger, write
    // the URL. Doing them together is what makes application instant and keeps them from
    // ever disagreeing about what is on.
    sync() {
      this.querySelectorAll('.pfacet__chip[data-value]').forEach((chip) => {
        const key = chip.closest('[ref="metals"]') ? 'metal' : 'stone';
        chip.setAttribute('aria-pressed', String(this.state[key] === chip.dataset.value));
      });
      const filtering = Boolean(this.state.stone || this.state.metal);
      if (this.all) this.all.setAttribute('aria-pressed', String(!filtering));
      this.paintTrigger();

      // Which card is last and alone means nothing once cells are hidden.
      this.grid.classList.toggle('is-filtering', filtering);

      let shown = 0;
      this.cells.forEach((c) => {
        const stones = (c.dataset.stones || '').split(' ');
        const ok = (!this.state.stone || stones.includes(this.state.stone))
                && (!this.state.metal || c.dataset.metal === this.state.metal);
        c.hidden = !ok;
        if (ok) shown++;
      });

      // The editorial breaks sit at fixed positions in the house order (§5). Once
      // the reader has narrowed the grid those positions mean nothing, so the
      // breaks withdraw rather than landing after whatever happens to be fourth.
      this.breaks.forEach((b) => { b.hidden = filtering; });

      if (this.none) this.none.hidden = shown !== 0;
      this.paint(shown, this.cells.length, filtering);

      const params = new URLSearchParams(location.search);
      ['stone', 'metal'].forEach((k) => {
        if (this.state[k]) params.set(k, this.state[k]); else params.delete(k);
      });
      const q = params.toString();
      history.replaceState(null, '', q ? `${location.pathname}?${q}` : location.pathname);
    }

    // The plural forms ride in on data attributes, so the wording is the locale
    // file's rather than the script's. %n is the shown figure, %t the total.
    //
    // Unfiltered, the total IS the shown figure and repeating it reads as noise,
    // so the plain form is used. With a filter on, the count has to say what it
    // is counting against or it stops being a readout: a shopper who narrows 19
    // pieces to 3 must be told the other 16 are hidden, not just handed a 3.
    //
    // The two forms are selected off DIFFERENT figures, because the noun agrees
    // with a different one in each. "1 piece" agrees with the shown count, but in
    // "1 of 19 pieces" it agrees with the total — selecting that one off the
    // shown count would print "1 of 19 piece".
    phrase(n, total, filtering) {
      return filtering
        ? (total === 1 ? this.dataset.countOfOne : this.dataset.countOfOther)
        : (n === 1 ? this.dataset.countOne : this.dataset.countOther);
    }

    // Every figure on this site is set in the body face with tabular figures,
    // because Prata's numerals are subsetted out of the webfont. So the count is
    // assembled as nodes rather than written as text: the words stay in the
    // display face and each figure gets its own span.
    paint(n, total, filtering) {
      if (!this.count) return;
      const form = this.phrase(n, total, filtering) || '%n';
      const frag = document.createDocumentFragment();
      const marks = /%[nt]/g;
      let last = 0;
      let hit;
      while ((hit = marks.exec(form)) !== null) {
        if (hit.index > last) frag.append(form.slice(last, hit.index));
        const fig = document.createElement('span');
        fig.className = 'u-num pcount__fig';
        fig.textContent = String(hit[0] === '%n' ? n : total);
        frag.append(fig);
        last = hit.index + hit[0].length;
      }
      if (last < form.length) frag.append(form.slice(last));
      this.count.replaceChildren(frag);
    }

    updatedCallback() { this.connectedCallback(); }
  }
  if (!customElements.get('pheres-filter')) customElements.define('pheres-filter', PheresFilter);

  // The sorts are ordinary form submissions and Shopify sorts them on the server. This
  // element only saves the reader a button: with scripting on, choosing an option
  // submits the form, and with it off the noscript button does.
  class PheresSort extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[ref="select"]');
      this.form = this.querySelector('[ref="form"]');
      if (!this.select || !this.form || this.bound) return;
      this.select.addEventListener('change', () => this.form.submit());
      this.bound = true;
    }

    updatedCallback() { this.connectedCallback(); }
  }
  if (!customElements.get('pheres-sort')) customElements.define('pheres-sort', PheresSort);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pheres-header"]) return;
  try {
    
  class PheresHeader extends HTMLElement {
    connectedCallback() {
      // Ahead of the guard below: a header with no drawer still pins.
      this.watchScroll();

      this.burger = this.querySelector('[ref="burger"]');
      this.drawer = this.querySelector('[ref="drawer"]');
      if (!this.burger || !this.drawer) return;
      this.toggle = this.toggle.bind(this);
      this.burger.addEventListener('click', this.toggle);
    }

    disconnectedCallback() {
      this.scrollIo?.disconnect();
      this.burger?.removeEventListener('click', this.toggle);
    }

    // An observer and not a scroll listener: a listener that writes layout is what
    // made the filter row bob, and it would need to know which element is scrolling,
    // which is .page-wrapper from 990px up and the window below that. The observer
    // reports the sentinel leaving the screen whichever one moved it.
    watchScroll() {
      const sentinel = this.parentElement?.querySelector('.hd__sentinel');
      if (!sentinel) return;
      this.scrollIo = new IntersectionObserver((entries) => {
        // The last entry: a fast scroll can deliver the crossing and the return together.
        this.classList.toggle('is-scrolled', !entries[entries.length - 1].isIntersecting);
      });
      this.scrollIo.observe(sentinel);
    }

    // morph.js can replace these nodes on a section re-render.
    updatedCallback() {
      this.disconnectedCallback();
      this.connectedCallback();
    }

    toggle() {
      const open = this.drawer.hasAttribute('hidden');
      this.drawer.toggleAttribute('hidden', !open);
      this.burger.setAttribute('aria-expanded', String(open));
    }
  }

  if (!customElements.get('pheres-header')) {
    customElements.define('pheres-header', PheresHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pheres-opening"] && !Shopify.designMode) return;
  try {
    
  // Attaches the video source only when it will be shown. Desktop shows the
  // full-resolution still and must not pay for a file it hides.
  class PheresOpening extends HTMLElement {
    connectedCallback() {
      this.mq = window.matchMedia('(max-width: 1023px)');
      this.calm = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.arm = this.arm.bind(this);
      this.arm();
      this.mq.addEventListener('change', this.arm);
    }

    disconnectedCallback() {
      this.mq?.removeEventListener('change', this.arm);
    }

    updatedCallback() {
      this.disconnectedCallback();
      this.connectedCallback();
    }

    arm() {
      const v = this.querySelector('.open__video[data-src]');
      if (!v || !this.mq.matches || this.calm.matches) return;
      v.src = v.dataset.src;
      delete v.dataset.src;
      // A blocked autoplay is not an error: the poster is the same frame.
      v.play().catch(() => {});
    }
  }

  if (!customElements.get('pheres-opening')) {
    customElements.define('pheres-opening', PheresOpening);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pheres-product"]) return;
  try {
    
  // The product page's behaviour, all of it enhancement over markup that already
  // works: the frames scroll natively, the chips are radios, and the button is a
  // real submit.
  class PheresProduct extends HTMLElement {
    connectedCallback() {
      this.teardown = [];
      this.initStickyBar();
      this.initGallery();
      this.initSizes();
      this.initButton();
      this.initZoom();
    }

    // Jewellery is bought on detail, and on a phone the only way to see a 0.19ct
    // stone is to fill the screen with it. A native <dialog> hands Escape, the
    // backdrop and the focus trap to the browser; the arrow keys move between
    // frames without leaving it.
    initZoom() {
      const dlg = this.querySelector('[ref="lightbox"]');
      const img = this.querySelector('[ref="lightboxImg"]');
      const close = this.querySelector('[ref="lightboxClose"]');
      const buttons = [...this.querySelectorAll('.pdp__zoom')];
      if (!dlg || !img || !buttons.length || typeof dlg.showModal !== 'function') return;

      let at = 0;
      const show = (i) => {
        at = (i + buttons.length) % buttons.length;
        const btn = buttons[at];
        // Only fetched on open — a 2400px macro must not sit in the initial load.
        img.src = btn.dataset.full;
        img.alt = btn.querySelector('img')?.alt || '';
      };

      const open = (e) => {
        show(Number(e.currentTarget.dataset.i) || 0);
        dlg.showModal();
      };
      buttons.forEach((b) => {
        b.addEventListener('click', open);
        this.teardown.push(() => b.removeEventListener('click', open));
      });

      const onKey = (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); show(at + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(at - 1); }
      };
      dlg.addEventListener('keydown', onKey);

      const shut = () => dlg.close();
      close?.addEventListener('click', shut);
      // Clicking the backdrop closes; clicking the photograph must not.
      const onBackdrop = (e) => { if (e.target === dlg) dlg.close(); };
      dlg.addEventListener('click', onBackdrop);
      this.teardown.push(() => {
        close?.removeEventListener('click', shut);
        dlg.removeEventListener('click', onBackdrop);
        dlg.removeEventListener('keydown', onKey);
        if (dlg.open) dlg.close();
      });
    }

    // The chip carries a bare numeral, because a chip this size has no room for
    // words. This live region is where it becomes a sentence — it is the only
    // thing that announces the choice to a screen reader — and it also writes the
    // chosen size into the sticky bar so the bar always names what it will add.
    initSizes() {
      const note = this.querySelector('[ref="sizeNote"]');
      const radios = [...this.querySelectorAll('.pdp__size input')];
      if (!radios.length) return;

      const tpl = note?.dataset.tpl || '';
      const badge = this.querySelector('[ref="stickySize"]');
      const legend = this.querySelector('.pdp__sizes-legend');
      const legendText = legend?.textContent;

      const onPick = (e) => {
        const { us, uk, eu, mm } = e.target.dataset;
        if (note) note.textContent = tpl.replace('__US__', us).replace('__MM__', mm);
        if (badge) badge.textContent = ' · US ' + us;
        // The label over the chips becomes the reading, in all three systems. A field
        // the size table does not carry drops out rather than printing a bare "UK".
        if (legend) {
          legend.textContent = ['US ' + us, uk && 'UK ' + uk, eu && 'EU ' + eu, mm + ' mm'].filter(Boolean).join(' · ');
          legend.classList.add('is-picked');
        }
        this.paintButtons(true);
      };
      radios.forEach((r) => {
        r.addEventListener('change', onPick);
        this.teardown.push(() => r.removeEventListener('change', onPick));
      });
      this.teardown.push(() => {
        if (note) note.textContent = '';
        if (badge) badge.textContent = '';
        if (legend) {
          legend.textContent = legendText;
          legend.classList.remove('is-picked');
        }
      });

      // Back from the measurer with ?size=6, the reading arrives already chosen. A
      // size with no chip is ignored, and a choice already made is left alone, because
      // morph.js can run this again long after the page loaded.
      const wanted = new URLSearchParams(location.search).get('size');
      const match = wanted && radios.find((r) => r.dataset.us === wanted);
      if (match && !radios.some((r) => r.checked)) {
        match.checked = true;
        match.dispatchEvent(new Event('change', { bubbles: true }));
      }

      this.paintButtons(radios.some((r) => r.checked));
    }

    // Both buttons carry all three labels as data attributes, rendered through
    // the locale files, so nothing here builds an English string.
    paintButtons(picked) {
      [this.querySelector('[ref="add"]'), this.querySelector('[ref="stickyAdd"]')].forEach((b) => {
        if (!b) return;
        b.textContent = picked ? b.dataset.lAdd : b.dataset.lChoose;
      });
    }

    // The button never greys out and never disables. With no size chosen it does
    // the next job instead of refusing: it scrolls the grid to 120px from the top
    // and puts focus on the first chip.
    initButton() {
      const add = this.querySelector('[ref="add"]');
      const sticky = this.querySelector('[ref="stickyAdd"]');
      const grid = this.querySelector('.pdp__size-grid');
      if (!add) return;

      const intercept = (e) => {
        const radios = [...this.querySelectorAll('.pdp__size input')];
        if (!radios.length) return;
        if (radios.some((r) => r.checked)) {
          // In flight: swap the label on whichever control was pressed, never lay
          // a spinner over a dead one.
          const pressed = e.currentTarget;
          pressed.textContent = pressed.dataset.lAdding || pressed.dataset.lAdd;
          return;
        }
        e.preventDefault();
        if (!grid) return;
        const y = grid.getBoundingClientRect().top + window.scrollY - 120;
        window.scrollTo({ top: y, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        radios[0].focus({ preventScroll: true });
      };

      add.addEventListener('click', intercept);
      sticky?.addEventListener('click', intercept);
      this.teardown.push(() => {
        add.removeEventListener('click', intercept);
        sticky?.removeEventListener('click', intercept);
      });
    }

    // The bar owns the stretch of page BELOW the real button and ABOVE the
    // footer. Two observers, no scroll handler.
    //
    // It watches the BUTTON, not the buy box: watching the box meant the bar was
    // already up at first paint, because the box starts a full gallery below the
    // fold and "not intersecting" was true before the reader had ever seen the
    // control the bar stands in for.
    initStickyBar() {
      this.bar = this.querySelector('[ref="sticky"]');
      const anchor = this.querySelector('.pdp__add');
      if (!this.bar || !anchor) return;

      let isPast = false;
      let isAtFooter = false;
      const sync = () => this.bar.toggleAttribute('hidden', !isPast || isAtFooter);

      // The root is grown 100,000px downwards, so the observed region is "the
      // viewport and everything below it". Intersecting therefore means the
      // button is in view OR still to come; NOT intersecting can only mean it has
      // gone off the TOP. Reading the state from boundingClientRect instead
      // leaves it stale: below-the-fold and above-the-fold are both "not
      // intersecting", so the discontinuous jump scroll restoration makes on a
      // back-navigation fires no callback and the bar keeps whatever state it had.
      this.io = new IntersectionObserver(
        ([e]) => {
          isPast = !e.isIntersecting;
          sync();
        },
        { rootMargin: '0px 0px 100000px 0px' }
      );
      this.io.observe(anchor);
      this.teardown.push(() => this.io?.disconnect());

      // A fixed bar sitting over the footer hides the legal and contact rows for
      // the whole length of the footer, so it stands down as soon as the footer
      // appears. Read-only reference to a section this file does not own.
      const foot = document.querySelector('.fo') || document.querySelector('footer');
      if (foot) {
        this.footIo = new IntersectionObserver(([e]) => {
          isAtFooter = e.isIntersecting;
          sync();
        });
        this.footIo.observe(foot);
        this.teardown.push(() => this.footIo?.disconnect());
      }

      this.teardown.push(() => this.bar.setAttribute('hidden', ''));
    }

    // The track is one horizontal scroller at EVERY width — it used to flatten
    // into a vertical stack above 1000px, which is the thing the client asked to
    // have removed. Which frame is showing is read from the scroll position
    // itself rather than tracked in a variable, so a swipe, an arrow key, the
    // arrows and the indicator all resolve to the same answer.
    initGallery() {
      const track = this.querySelector('[ref="track"]');
      if (!track) return;

      const shots = [...track.querySelectorAll('.pdp__shot')];
      const dots = [...this.querySelectorAll('.pdp__dot')];
      const status = this.querySelector('[ref="status"]');
      if (shots.length < 2) return;

      const gallery = this.querySelector('[ref="gallery"]');
      const prev = this.querySelector('[ref="prev"]');
      const next = this.querySelector('[ref="next"]');

      const statusTpl = status?.dataset.tpl || '';
      const paint = (i) => {
        dots.forEach((d, n) => d.classList.toggle('is-on', n === i));
        if (status) {
          status.textContent = statusTpl.replace('__N__', i + 1).replace('__T__', shots.length);
        }
        // Disabled rather than removed, so the two controls never change place
        // under the pointer as the reader moves through the frames.
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === shots.length - 1;
      };

      const spy = new IntersectionObserver(
        (entries) => {
          const seen = entries
            .filter((e) => e.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
          if (seen) paint(shots.indexOf(seen.target));
        },
        { root: track, threshold: 0.6 }
      );
      shots.forEach((s) => spy.observe(s));
      this.teardown.push(() => spy.disconnect());

      if (prev && next) {
        // Which frame the track is on, by proximity rather than by a counter, so
        // an arrow pressed after a swipe moves relative to what is on screen.
        // Offsets are measured against the FIRST frame, not against the track, so
        // that any padding on the gallery cannot put a raw offsetLeft out.
        const frameAt = () => {
          const base = shots[0].offsetLeft;
          let best = 0;
          let near = Infinity;
          shots.forEach((s, i) => {
            const d = Math.abs(s.offsetLeft - base - track.scrollLeft);
            if (d < near) { near = d; best = i; }
          });
          return best;
        };

        const step = (d) => () => {
          const i = Math.min(shots.length - 1, Math.max(0, frameAt() + d));

          // MEASURED ON THE LIVE PREVIEW, not assumed: on this track
          // `scroll-behavior: smooth` never completes a PROGRAMMATIC scroll.
          // scrollIntoView, scrollTo and scrollBy each left scrollLeft at 0 on a
          // five-frame gallery — the snap engine cancels the animation on a
          // `x mandatory` container and the frames never moved. Assigning
          // scrollLeft with the element's behaviour temporarily set to auto is
          // the one form that does move it. Swiping is untouched by any of this,
          // because a swipe is a user scroll and only programmatic ones are
          // cancelled — which is exactly why the bug was invisible on the phone.
          const was = track.style.scrollBehavior;
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = shots[i].offsetLeft - shots[0].offsetLeft;
          track.style.scrollBehavior = was;

          // Painted here as well as from the observer. A click already knows
          // where it is going, and the indicator should not wait for an
          // intersection to confirm what the reader has just asked for.
          paint(i);
        };

        const goPrev = step(-1);
        const goNext = step(1);
        prev.addEventListener('click', goPrev);
        next.addEventListener('click', goNext);
        gallery?.classList.add('is-paged');
        this.teardown.push(() => {
          prev.removeEventListener('click', goPrev);
          next.removeEventListener('click', goNext);
          gallery?.classList.remove('is-paged');
        });
      }

      paint(0);
    }

    disconnectedCallback() {
      this.teardown?.forEach((fn) => fn());
      this.teardown = [];
    }

    // morph.js replaces unchanged subtrees, so state must re-arm here too.
    updatedCallback() {
      this.disconnectedCallback();
      this.connectedCallback();
    }
  }

  if (!customElements.get('pheres-product')) {
    customElements.define('pheres-product', PheresProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pheres-sizeguide"] && !Shopify.designMode) return;
  try {
    
  // A measured graphic never shrinks to its container, so on a narrow enough
  // screen it scrolls — and a scroll nobody can see is a graphic that looks
  // clipped. The attribute is set only when there is genuinely somewhere to go.
  function pheresSizerOverflow() {
    var wells = document.querySelectorAll('.sizeguide__scroll');
    for (var i = 0; i < wells.length; i++) {
      if (wells[i].scrollWidth - wells[i].clientWidth > 1) {
        wells[i].setAttribute('data-overflow', '');
      } else {
        wells[i].removeAttribute('data-overflow');
      }
    }
  }

  class PheresSizeguide extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[ref="print"]');
      this.onPrint = () => window.print();
      this.btn?.addEventListener('click', this.onPrint);
      pheresSizerOverflow();
    }
    disconnectedCallback() { this.btn?.removeEventListener('click', this.onPrint); }
    updatedCallback() { this.connectedCallback(); }
  }
  if (!customElements.get('pheres-sizeguide')) customElements.define('pheres-sizeguide', PheresSizeguide);

  // The button lives inside a plain section, so wire it without requiring the
  // custom element to wrap the markup.
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.sizeguide__print .pheres-btn');
    if (b) window.print();
  });

  (function () {
    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; pheresSizerOverflow(); });
    }

    // A window `resize` listener measured the wrong frame more often than the
    // right one: the event fires before the new layout is committed, and a single
    // rAF was not always enough. ResizeObserver fires on the well itself, after
    // it has been laid out, which is the only moment the answer can be correct.
    function observe() {
      if (!window.ResizeObserver) return;
      var ro = new ResizeObserver(pheresSizerOverflow);
      var wells = document.querySelectorAll('.sizeguide__scroll');
      for (var i = 0; i < wells.length; i++) ro.observe(wells[i]);
    }

    document.addEventListener('DOMContentLoaded', function () { schedule(); observe(); });
    window.addEventListener('load', schedule);
    window.addEventListener('resize', schedule);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    if (document.readyState !== 'loading') observe();
    schedule();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pheres-together"] && !Shopify.designMode) return;
  try {
    
  // Fetched on approach rather than on load: a fourth of the page's images for a
  // block most readers never reach is the wrong trade on a mobile connection.
  class PheresTogether extends HTMLElement {
    connectedCallback() {
      if (this.loaded || !this.dataset.url) return;
      this.io = new IntersectionObserver((entries) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        this.io.disconnect();
        this.load();
      }, { rootMargin: '400px 0px' });
      this.io.observe(this);
    }

    async load() {
      this.loaded = true;
      try {
        const res = await fetch(this.dataset.url);
        if (!res.ok) return;
        const html = new DOMParser().parseFromString(await res.text(), 'text/html');
        const section = html.querySelector('.pheres-together');
        // No recommendations is a normal answer, not a failure. Say nothing.
        if (section) this.replaceWith(section);
      } catch (e) {
        // A failed cross-sell must never take the product page with it.
      }
    }

    disconnectedCallback() { this.io?.disconnect(); }
    updatedCallback() { this.connectedCallback(); }
  }

  if (!customElements.get('pheres-together')) {
    customElements.define('pheres-together', PheresTogether);
  }

  } catch(e) { console.error(e); }
})();
})();
